import {axiosInstance} from '../../utils';

const actions = {
  FETCH_BRANDS_REQUESTED: 'FETCH_BRANDS_REQUESTED',
  FETCH_BRANDS_SUCCEEDED: 'FETCH_BRANDS_SUCCEEDED',
  FETCH_BRANDS_FAILED: 'FETCH_BRANDS_FAILED',

  FETCH_BRAND_REQUESTED: 'FETCH_BRAND_REQUESTED',
  FETCH_BRAND_SUCCEEDED: 'FETCH_BRAND_SUCCEEDED',
  FETCH_BRAND_FAILED: 'FETCH_BRAND_FAILED',

  DELETE_BRAND_REQUESTED: 'DELETE_BRAND_REQUESTED',
  DELETE_BRAND_SUCCEEDED: 'DELETE_BRAND_SUCCEEDED',
  DELETE_BRAND_FAILED: 'DELETE_BRAND_FAILED',

  CLEAR_ALERT_MESSAGE: 'CLEAR_ALERT_MESSAGE',

  SEARCH_BRANDS_REQUESTED: 'SEARCH_BRANDS_REQUESTED',
  SEARCH_BRANDS_SUCCESS: 'SEARCH_BRANDS_SUCCESS',
  SEARCH_BRANDS_FAILED: 'SEARCH_BRANDS_FAILED',

  clearAlertMessage: (params = undefined) => {
    return {
      type: actions.CLEAR_ALERT_MESSAGE,
      payload: params,
    };
  },

  fetchBrands: (params = undefined) => {
    return {
      type: params.search
          ? actions.SEARCH_BRANDS_REQUESTED
          : actions.FETCH_BRANDS_REQUESTED,
      payload: params,
    };
  },

  searchBrands: async (params = {}) => {
    const url = `brands/search`;
    try {
      const brands = await axiosInstance.get(url, {params});
      return brands.data;
    } catch (error) {
      console.debug({error});
      throw error;
    }
  },

  fetchBrand: (id = undefined) => {
    return {
      type: actions.FETCH_BRAND_REQUESTED,
      payload: id,
    };
  },

  removeBrand: (id = undefined) => {
    return {
      type: actions.DELETE_BRAND_REQUESTED,
      payload: id,
    };
  },

  getBrands: async (params = undefined) => {
    const url = `brands`;

    try {
      const brands = await axiosInstance.get(url, {params});
      return brands.data;
    } catch (error) {
      throw error;
    }
  },

  getBrand: async (brandId = undefined) => {
    const url = `brands/` + brandId;

    try {
      const brand = await axiosInstance.get(url);
      return brand.data;
    } catch (error) {
      throw error;
    }
  },

  deleteBrand: async (brandId = undefined) => {
    const url = `brands/` + brandId;
    try {
      const brands = await axiosInstance.delete(url);
      return brands.data;
    } catch (error) {
      throw error;
    }
  },
};
export default actions;
